import { useEffect, useRef, useState } from 'react';
import charPoint from './assets/char_point.png';
import charGuide from './assets/char_guide.png';

const mustRead = [
  'タイで美容ビジネスを展開している',
  '価格訴求だけでなく信頼感も高めたい',
  'LPやSNSの見せ方をブランド基準で整えたい',
];

const audienceTags = [
  '病院・クリニック',
  '美容クリニック',
  'エステサロン',
  '脱毛サロン',
  'リラクゼーションサロン',
  '美容機器販売',
];

const commonProblems = [
  {
    title: '広告は出しているのに、印象に残りにくい',
    body: 'キャンペーン訴求だけでは比較に埋もれやすく、ブランドとしての記憶が残りにくくなります。',
    label: 'Problem 01',
  },
  {
    title: 'LPとSNSで見せ方がバラついてしまう',
    body: '接点ごとに印象が変わると、安心感や世界観が積み上がらず、信頼形成につながりにくくなります。',
    label: 'Problem 02',
  },
  {
    title: 'タレント活用に興味はあるが、重すぎて踏み切れない',
    body: '費用や進め方の見えにくさがハードルになり、ブランド訴求の選択肢として使いにくく感じられます。',
    label: 'Problem 03',
  },
  {
    title: '採用や体制面でも余裕がなく、発信まで手が回らない',
    body: '集客だけでなく人手不足も重なり、ブランドづくりに必要な発信が後回しになりやすいです。',
    label: 'Problem 04',
  },
];

const seriousIssues = [
  '価格競争に巻き込まれ、ブランドの価値が伝わりにくくなる',
  '第一印象で安心感を持ってもらえず、検討段階で離脱されやすくなる',
  '単発施策の積み上げで終わり、長期的なブランド資産にならない',
];

const enterpriseApproach = [
  {
    title: 'タレントを継続起用',
    body: '単発ではなく、一定期間を通して印象を定着させる。',
  },
  {
    title: '各接点の世界観を統一',
    body: 'LP、広告、SNSでブレないブランド体験をつくる。',
  },
  {
    title: '信頼形成に投資',
    body: '短期の獲得だけでなく、中長期の認知と安心感を積み上げる。',
  },
];

const whyUs = [
  {
    title: 'ブランド訴求に使いやすい',
    body: '派手な売り込みではなく、安心感や上質感を伝える用途と相性が良い設計です。',
  },
  {
    title: '継続活用のイメージを持ちやすい',
    body: '単発の話題づくりではなく、長く使えるブランド表現として相談しやすくなります。',
  },
  {
    title: '美容領域の見せ方に合わせやすい',
    body: '見た目や雰囲気が重要な美容領域だからこそ、タレント活用の価値を乗せやすくなります。',
  },
];

const values = [
  {
    title: '信頼',
    body: '顔が見えることで、安心感と親近感を伝えやすくなります。',
  },
  {
    title: 'ブランディング',
    body: 'LP、SNS、広告の見せ方に統一感が出て、世界観が育ちやすくなります。',
  },
  {
    title: '集客アップ',
    body: 'ブランドの印象改善が、結果として反応率や検討率の改善につながります。',
  },
];

const reasons = [
  {
    title: 'ブランド目線で導入を考えやすい',
    body: '獲得数の話だけでなく、ブランドの空気感や信頼感まで含めて相談できます。',
    accent: '#f7e4d7',
  },
  {
    title: '中長期の活用につなげやすい',
    body: '最初の導入から、継続的な見せ方まで視野に入れたコミュニケーション設計がしやすくなります。',
    accent: '#e2f0ea',
  },
  {
    title: '美容事業者の接点設計と相性が良い',
    body: 'LP、SNS、バナー、予約導線など、印象設計が重要な接点で活用しやすい前提です。',
    accent: '#e7edf7',
  },
];

const useCases = [
  {
    label: 'case.1',
    kicker: 'WEB活用事例',
    title: '公式サイト・ポータルサイト',
    body: '公式サイトや比較・掲載系のポータルで、ブランドの第一印象を整えたいときに。',
  },
  {
    label: 'case.2',
    kicker: 'WEB活用事例',
    title: 'バナー広告',
    body: '配信バナーやキャンペーンクリエイティブで、統一感のある見せ方を広げたいときに。',
  },
];

const flowSteps = [
  {
    step: 'STEP.01',
    title: 'タレント選択',
    icon: 'list',
    body: 'ご希望の方向性や重視したいポイントを伺いながら、候補イメージをすり合わせます。',
  },
  {
    step: 'STEP.02',
    title: '審査',
    icon: 'checklist',
    body: 'ご相談内容や活用イメージをもとに、進行条件や活用可否を確認していきます。',
  },
  {
    step: 'STEP.03',
    title: 'ご契約',
    icon: 'document',
    body: '条件のすり合わせ後、利用プランや期間を整理しながらご契約へ進みます。',
  },
  {
    step: 'STEP.04',
    title: '素材提供・制作',
    icon: 'meeting',
    body: '写真やバナー、LPなど必要な接点を確認しながら、活用に向けた制作を進めます。',
  },
  {
    step: 'STEP.05',
    title: 'ご利用開始',
    icon: 'monitor',
    body: '公開・配信準備を整えたあと、ブランド施策としての活用をスタートします。',
  },
];

const faqs = [
  {
    question: '費用はどのくらいですか？',
    answer: '最安5万THB〜ご提供させていただきます。またインフルエンサーごとに金額が異なり、業種や利用期間によって金額が変動する場合があります。まずはお気軽にご相談ください。',
  },
  {
    question: '最低利用期間はどのくらいですか？',
    answer: '最短3ヶ月からご利用いただけます。通常、タレント起用だと年間縛りを求めてくる代理店や企業体が多く存在しますが、その場合は月で安くとも年間では大きな額の負担が強いられます。初めての企業様向けのお得なプランもご用意しておりますので、お気軽にご相談ください。',
  },
  {
    question: '肖像利用範囲に規制はありますか？',
    answer: '基本的には通常契約と変わらない範囲でご利用いただけます。但しインフルエンサーによって異なる部分もございます。',
  },
  {
    question: '契約後は全てのインフルエンサーさんの肖像を利用できますか？',
    answer: '恐れ入りますが、1契約につきタレントさん1名をお選びいただき、肖像を利用いただく流れになります。',
  },
  {
    question: '費用対効果を知りたい。',
    answer: '詳しい資料を用いながらご説明させて頂きます。',
  },
];

const shellStyle = {
  width: 'min(1180px, calc(100% - 28px))',
  margin: '0 auto',
};

function SectionIntro({ overline, title, body, align = 'left' }) {
  return (
    <div style={{ marginBottom: 26, textAlign: align }}>
      <p
        style={{
          margin: 0,
          display: 'inline-flex',
          padding: '7px 14px',
          borderRadius: 999,
          background: '#fff2d9',
          color: '#a96a10',
          fontSize: 12,
          fontWeight: 800,
          letterSpacing: '0.08em',
        }}
      >
        {overline}
      </p>
      <h2
        style={{
          margin: '16px 0 0',
          fontSize: 'clamp(28px, 4vw, 54px)',
          lineHeight: 1.1,
          letterSpacing: '-0.04em',
        }}
      >
        {title}
      </h2>
      {body ? (
        <p style={{ margin: '14px 0 0', color: '#667a73', lineHeight: 1.9, fontSize: 16, maxWidth: 760 }}>
          {body}
        </p>
      ) : null}
    </div>
  );
}

function PlaceholderVisual({ label, tone = 'warm', height = 260 }) {
  const map = {
    warm: ['#f8d8c5', '#fff6ef'],
    mint: ['#d7ebe3', '#f5fbf8'],
    blue: ['#dce6f7', '#f6f9fe'],
    gold: ['#f6dfb6', '#fff8ed'],
  };
  const [a, b] = map[tone] || map.warm;
  return (
    <div
      style={{
        minHeight: height,
        borderRadius: 28,
        border: '1px solid rgba(20, 49, 38, 0.08)',
        background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 18,
          borderRadius: 22,
          border: '1px dashed rgba(20, 49, 38, 0.18)',
          display: 'grid',
          placeItems: 'center',
          padding: 16,
          textAlign: 'center',
          color: '#4f665d',
          fontWeight: 700,
          lineHeight: 1.6,
        }}
      >
        {label}
      </div>
      <div
        style={{
          position: 'absolute',
          right: -28,
          bottom: -34,
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.45)',
        }}
      />
    </div>
  );
}

function PointCard({ item, index }) {
  return (
    <article
      style={{
        background: '#fff',
        border: '1px solid rgba(20,49,38,0.08)',
        borderRadius: 26,
        padding: 28,
        boxShadow: '0 18px 44px rgba(14, 40, 32, 0.08)',
      }}
    >
      <p style={{ margin: 0, color: '#d4851f', fontSize: 12, fontWeight: 800 }}>POINT 0{index + 1}</p>
      <h3 style={{ margin: '14px 0 0', fontSize: 24, lineHeight: 1.45 }}>{item}</h3>
    </article>
  );
}

export default function LP01() {
  const [openFaqIndex, setOpenFaqIndex] = useState(0);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const heroSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = heroSectionRef.current?.offsetHeight ?? 0;
      const triggerPoint = Math.max(heroHeight - 140, 280);
      setShowStickyHeader(window.scrollY > triggerPoint);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div style={{ background: 'linear-gradient(90deg, #f7eefb 0%, #f5f7ff 50%, #eef8ff 100%)', color: '#18352b', fontFamily: "'Noto Sans JP', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;900&family=Noto+Serif+JP:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        body { margin: 0; }
        .lp01-grid-2,
        .lp01-grid-3,
        .lp01-hero,
        .lp01-cta-row,
        .lp01-comparison,
        .lp01-media-row,
        .lp01-audience-grid,
        .lp01-problem-circles,
        .lp01-issue-bubbles,
        .lp01-hurdle-grid,
        .lp01-attention-thumbs,
        .lp01-answer-lines,
        .lp01-subscription-layout,
        .lp01-asset-layout,
        .lp01-brand-layout,
        .lp01-reason-slide {
          display: grid;
          gap: 18px;
        }
        .lp01-grid-2 {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .lp01-grid-3,
        .lp01-comparison,
        .lp01-media-row {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .lp01-audience-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 12px 22px;
        }
        .lp01-problem-circles {
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 28px;
          align-items: start;
        }
        .lp01-attention-thumbs {
          position: absolute;
          top: 114px;
          right: 78px;
          width: 250px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }
        .lp01-attention-thumb {
          min-height: 112px;
          border-radius: 6px;
          overflow: hidden;
          background: rgba(255,255,255,0.7);
          border: 1px solid rgba(255,255,255,0.75);
          box-shadow: 0 12px 24px rgba(97, 136, 176, 0.12);
          display: grid;
          place-items: center;
          text-align: center;
          color: #4e6f87;
          font-size: 12px;
          font-weight: 700;
          line-height: 1.5;
          padding: 10px;
        }
        .lp01-answer-lines {
          gap: 14px;
        }
        .lp01-subscription-layout {
          grid-template-columns: minmax(0, 1fr) minmax(320px, 1fr);
          align-items: center;
          gap: 28px;
        }
        .lp01-asset-layout {
          grid-template-columns: minmax(440px, 1fr) minmax(0, 1fr);
          align-items: center;
          gap: 34px;
        }
        .lp01-brand-layout {
          grid-template-columns: minmax(520px, 1fr) minmax(0, 1fr);
          align-items: start;
          gap: 34px;
        }
        .lp01-reason-slide {
          grid-template-columns: 1fr;
        }
        .lp01-issue-bubbles {
          position: absolute;
          top: 124px;
          right: 205px;
          width: 420px;
          grid-template-columns: 1.2fr 0.9fr;
          grid-template-areas:
            "large small"
            "large bottom";
          align-items: start;
          gap: 18px;
        }
        .lp01-issue-bubble {
          border-radius: 50%;
          border: 3px solid #b46adf;
          background: rgba(255,255,255,0.92);
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #9a5bd0;
          font-weight: 800;
          line-height: 1.55;
          box-shadow: 0 16px 36px rgba(163, 121, 215, 0.1);
          padding: 20px;
        }
        .lp01-issue-bubble.large {
          grid-area: large;
          width: 220px;
          height: 220px;
          font-size: 18px;
          justify-self: center;
          align-self: center;
        }
        .lp01-issue-bubble.small {
          grid-area: small;
          width: 176px;
          height: 176px;
          font-size: 16px;
          justify-self: start;
        }
        .lp01-issue-bubble.bottom {
          grid-area: bottom;
          width: 176px;
          height: 176px;
          font-size: 16px;
          justify-self: center;
          margin-top: -8px;
        }
        .lp01-issue-figure {
          position: absolute;
          left: 210px;
          bottom: 0;
          width: 416px;
          height: 546px;
        }
        .lp01-issue-figure-head {
          position: absolute;
          top: 52px;
          left: 50%;
          transform: translateX(-50%);
          width: 126px;
          height: 160px;
          border-radius: 46% 46% 44% 44%;
          background: linear-gradient(180deg, #ffe6d9 0%, #ffd2bf 100%);
          z-index: 3;
        }
        .lp01-issue-figure-hair {
          position: absolute;
          top: 18px;
          left: 50%;
          transform: translateX(-50%);
          width: 170px;
          height: 120px;
          border-radius: 48% 48% 42% 42%;
          background: linear-gradient(180deg, #4a362e 0%, #2f211d 100%);
          z-index: 2;
        }
        .lp01-issue-figure-body {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 230px;
          height: 260px;
          border-radius: 120px 120px 12px 12px;
          background: linear-gradient(180deg, #fefefe 0%, #e9edf4 100%);
          box-shadow: 0 20px 36px rgba(0,0,0,0.08);
          z-index: 1;
        }
        .lp01-issue-figure-inner {
          position: absolute;
          top: 78px;
          left: 50%;
          transform: translateX(-50%);
          width: 96px;
          height: 110px;
          border-radius: 20px 20px 8px 8px;
          background: linear-gradient(180deg, #b5d8f8 0%, #90c0ef 100%);
          z-index: 2;
        }
        .lp01-issue-figure-caption {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          text-align: center;
          color: rgba(24,53,43,0.6);
          font-size: 14px;
          font-weight: 700;
          z-index: 4;
        }
        .lp01-hurdle-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 20px;
        }
        .lp01-hurdle-card {
          display: grid;
          gap: 14px;
        }
        .lp01-hurdle-image {
          min-height: 146px;
          border-radius: 6px;
          border: 1px solid rgba(24,53,43,0.08);
          display: grid;
          place-items: center;
          text-align: center;
          padding: 16px;
          color: #546a61;
          font-size: 14px;
          font-weight: 700;
          line-height: 1.6;
        }
        .lp01-hurdle-caption {
          margin: 0;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          color: #202020;
        }
        .lp01-attention-figure {
          position: absolute;
          left: 220px;
          bottom: 0;
          width: 360px;
          height: 420px;
        }
        .lp01-attention-figure-head {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 132px;
          height: 166px;
          border-radius: 46% 46% 44% 44%;
          background: linear-gradient(180deg, #ffe6d9 0%, #ffd4c0 100%);
          z-index: 3;
        }
        .lp01-attention-figure-hair {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 162px;
          height: 108px;
          border-radius: 48% 48% 42% 42%;
          background: linear-gradient(180deg, #6d4b3a 0%, #3e2c25 100%);
          z-index: 2;
        }
        .lp01-attention-figure-body {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 272px;
          height: 260px;
          border-radius: 120px 120px 0 0;
          background: linear-gradient(180deg, #f3f8c8 0%, #d7ee92 100%);
          z-index: 1;
        }
        .lp01-attention-figure-legs {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 320px;
          height: 120px;
          display: flex;
          justify-content: space-between;
          padding: 0 16px;
          z-index: 0;
        }
        .lp01-attention-leg {
          width: 118px;
          height: 120px;
          border-radius: 28px 28px 0 0;
          background: linear-gradient(180deg, #354564 0%, #212b42 100%);
        }
        .lp01-attention-figure-caption {
          position: absolute;
          bottom: 84px;
          left: 50%;
          transform: translateX(-50%);
          width: 94%;
          text-align: center;
          color: rgba(24,53,43,0.62);
          font-size: 14px;
          font-weight: 700;
          z-index: 4;
        }
        .lp01-attention-arrow {
          position: absolute;
          top: 104px;
          left: 50%;
          transform: translateX(-50%);
          width: 56px;
          height: 56px;
        }
        .lp01-attention-arrow::before,
        .lp01-attention-arrow::after {
          content: '';
          position: absolute;
          left: 50%;
          width: 38px;
          height: 38px;
          border-right: 3px solid rgba(74, 74, 74, 0.7);
          border-bottom: 3px solid rgba(74, 74, 74, 0.7);
          transform: translateX(-50%) rotate(45deg);
        }
        .lp01-attention-arrow::before {
          top: -4px;
        }
        .lp01-attention-arrow::after {
          top: 18px;
        }
        .lp01-answer-figure {
          position: absolute;
          bottom: 0;
          width: 300px;
          height: 320px;
          z-index: 2;
        }
        .lp01-answer-figure.left {
          left: 120px;
        }
        .lp01-answer-figure.right {
          right: 120px;
        }
        .lp01-answer-head {
          position: absolute;
          top: 42px;
          left: 50%;
          transform: translateX(-50%);
          width: 122px;
          height: 148px;
          border-radius: 46% 46% 44% 44%;
          background: linear-gradient(180deg, #ffe6d9 0%, #ffd4c0 100%);
          z-index: 3;
        }
        .lp01-answer-hair {
          position: absolute;
          top: 8px;
          left: 50%;
          transform: translateX(-50%);
          width: 150px;
          height: 88px;
          border-radius: 48% 48% 42% 42%;
          background: linear-gradient(180deg, #5d4034 0%, #31221e 100%);
          z-index: 2;
        }
        .lp01-answer-body {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 222px;
          height: 190px;
          border-radius: 100px 100px 0 0;
          z-index: 1;
        }
        .lp01-answer-figure.left .lp01-answer-body {
          background: linear-gradient(180deg, #d7e8ff 0%, #bfdcff 100%);
        }
        .lp01-answer-figure.right .lp01-answer-body {
          background: linear-gradient(180deg, #f7f7fa 0%, #ececf3 100%);
        }
        .lp01-answer-caption {
          position: absolute;
          bottom: 56px;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          text-align: center;
          color: rgba(24,53,43,0.62);
          font-size: 13px;
          font-weight: 700;
          z-index: 4;
        }
        .lp01-subscription-stack {
          width: 120px;
          display: grid;
          gap: 4px;
        }
        .lp01-subscription-stack-item {
          min-height: 54px;
          background: #9d9d9d;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
        }
        .lp01-subscription-axis {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 44px;
          height: 2px;
          background: rgba(40, 40, 40, 0.48);
        }
        .lp01-subscription-bubble {
          width: 132px;
          height: 132px;
          border-radius: 50%;
          border: 3px solid #67b8e5;
          background: rgba(255,255,255,0.96);
          display: grid;
          place-items: center;
          text-align: center;
          color: #58a6d7;
          font-weight: 900;
          line-height: 1.4;
        }
        .lp01-subscription-price {
          min-width: 144px;
          min-height: 34px;
          background: linear-gradient(90deg, #c92bd7 0%, #f15ad2 100%);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 900;
          padding: 0 14px;
        }
        .lp01-asset-collage {
          position: relative;
          min-height: 470px;
        }
        .lp01-asset-main {
          position: absolute;
          left: 0;
          top: 0;
          width: 78%;
          height: 100%;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 18px 44px rgba(14,40,32,0.1);
          overflow: hidden;
          display: grid;
          grid-template-columns: 0.48fr 0.52fr;
          grid-template-rows: 0.58fr 0.42fr;
          gap: 2px;
        }
        .lp01-asset-side {
          position: absolute;
          top: 0;
          right: 34px;
          width: 120px;
          height: 100%;
          display: grid;
          gap: 10px;
        }
        .lp01-asset-side-card {
          border-radius: 4px;
          border: 1px solid rgba(255,255,255,0.72);
          box-shadow: 0 12px 24px rgba(97, 136, 176, 0.12);
          display: grid;
          place-items: center;
          text-align: center;
          color: #546f87;
          font-size: 12px;
          font-weight: 700;
          line-height: 1.45;
          padding: 10px;
          background: rgba(255,255,255,0.9);
        }
        .lp01-asset-tag {
          position: absolute;
          left: 0;
          min-width: 420px;
          min-height: 70px;
          background: #55aee0;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 900;
          letter-spacing: -0.03em;
          box-shadow: 0 18px 36px rgba(85, 174, 224, 0.18);
        }
        .lp01-brand-stage {
          position: relative;
          min-height: 390px;
        }
        .lp01-brand-panel-back {
          position: absolute;
          left: 130px;
          top: 122px;
          width: 430px;
          height: 240px;
          border-radius: 18px;
          background: linear-gradient(135deg, #c7f0e9 0%, #d9c5f4 100%);
          z-index: 0;
        }
        .lp01-brand-panel-front {
          position: absolute;
          left: 72px;
          top: 8px;
          width: 430px;
          height: 300px;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 24px 44px rgba(14, 40, 32, 0.12);
          overflow: hidden;
          transform: rotate(-2deg);
          z-index: 2;
          display: grid;
          grid-template-columns: 0.42fr 0.58fr;
          grid-template-rows: auto 1fr auto;
        }
        .lp01-brand-panel-overlay {
          position: absolute;
          left: 262px;
          top: 68px;
          width: 286px;
          height: 196px;
          border-radius: 10px;
          background: rgba(255,255,255,0.96);
          box-shadow: 0 18px 36px rgba(120, 180, 215, 0.14);
          overflow: hidden;
          z-index: 3;
          display: grid;
          place-items: center;
          text-align: center;
          color: #6c8ba3;
          font-weight: 700;
          line-height: 1.6;
          padding: 16px;
        }
        .lp01-brand-cta {
          position: absolute;
          left: 10px;
          bottom: 42px;
          min-width: 288px;
          min-height: 60px;
          background: #55aee0;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 900;
          letter-spacing: -0.03em;
          box-shadow: 0 18px 36px rgba(85, 174, 224, 0.18);
          z-index: 4;
        }
        .lp01-brand-person {
          position: absolute;
          right: 56px;
          bottom: 0;
          width: 250px;
          height: 310px;
          z-index: 3;
        }
        .lp01-brand-person-head {
          position: absolute;
          top: 26px;
          left: 50%;
          transform: translateX(-50%);
          width: 110px;
          height: 136px;
          border-radius: 46% 46% 44% 44%;
          background: linear-gradient(180deg, #ffe6d9 0%, #ffd4c0 100%);
          z-index: 3;
        }
        .lp01-brand-person-hair {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 132px;
          height: 84px;
          border-radius: 48% 48% 42% 42%;
          background: linear-gradient(180deg, #45312b 0%, #241916 100%);
          z-index: 2;
        }
        .lp01-brand-person-body {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 186px;
          height: 174px;
          border-radius: 90px 90px 0 0;
          background: linear-gradient(180deg, #bfe0fb 0%, #95c9f4 100%);
          z-index: 1;
        }
        .lp01-brand-person-caption {
          position: absolute;
          bottom: 46px;
          left: 50%;
          transform: translateX(-50%);
          width: 92%;
          text-align: center;
          color: rgba(24,53,43,0.62);
          font-size: 13px;
          font-weight: 700;
          z-index: 4;
        }
        .lp01-brand-banner {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 62px;
          padding: 0 28px;
          background: #55aee0;
          color: #fff;
          font-size: 26px;
          font-weight: 900;
          letter-spacing: -0.03em;
          position: relative;
          box-shadow: 0 18px 36px rgba(85, 174, 224, 0.18);
        }
        .lp01-reason-arrow {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #67b8e5;
          color: #fff;
          display: grid;
          place-items: center;
          font-size: 30px;
          line-height: 1;
          box-shadow: 0 14px 28px rgba(103, 184, 229, 0.22);
        }
        .lp01-hero {
          gap: 0;
        }
        .lp01-problem-circle {
          width: min(100%, 248px);
          margin: 0 auto;
          border-radius: 24px;
          border: 3px solid #b46adf;
          background: rgba(255,255,255,0.82);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 26px;
          box-shadow: 0 16px 36px rgba(163, 121, 215, 0.1);
        }
        .lp01-problem-icon {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border: 2px solid rgba(120, 120, 120, 0.45);
          display: grid;
          place-items: center;
          color: #777;
          font-size: 24px;
          margin-bottom: 18px;
          background: rgba(255,255,255,0.9);
        }
        .lp01-problem-title {
          margin: 0;
          font-size: 17px;
          line-height: 1.65;
          font-weight: 700;
          color: #333;
        }
        .lp01-problem-emphasis {
          color: #9f4ed1;
          font-weight: 900;
        }
        .lp01-hero-stage {
          position: relative;
          overflow: hidden;
          min-height: clamp(560px, 68vh, 680px);
          border-radius: 42px 42px 0 0;
          background:
            radial-gradient(circle at 14% 16%, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.72) 25%, transparent 54%),
            radial-gradient(circle at 74% 18%, rgba(255, 225, 238, 0.34) 0%, transparent 30%),
            radial-gradient(circle at 86% 42%, rgba(218, 236, 255, 0.36) 0%, transparent 32%),
            radial-gradient(circle at 20% 84%, rgba(223, 202, 255, 0.34) 0%, transparent 32%),
            linear-gradient(118deg, #fffdfd 0%, #f7f2ff 34%, #f3f9ff 68%, #fff6fa 100%);
          border: 1px solid rgba(204, 206, 243, 0.44);
          box-shadow: 0 32px 80px rgba(121, 130, 189, 0.12);
        }
        .lp01-hero-shell {
          position: relative;
          z-index: 1;
          width: min(100%, 1440px);
          min-height: inherit;
          margin: 0 auto;
          padding: 28px 36px 22px 48px;
          display: grid;
          grid-template-columns: minmax(360px, 0.37fr) minmax(0, 0.63fr);
          align-items: start;
          gap: clamp(22px, 3vw, 44px);
        }
        .lp01-hero-shell::before {
          content: '';
          position: absolute;
          left: -6%;
          right: 42%;
          bottom: -22px;
          height: 210px;
          background:
            linear-gradient(10deg, rgba(255,255,255,0) 8%, rgba(183, 198, 255, 0.2) 34%, rgba(255,255,255,0.72) 48%, rgba(255, 211, 238, 0.2) 64%, rgba(255,255,255,0) 84%),
            radial-gradient(ellipse at 28% 60%, rgba(168, 179, 255, 0.2) 0%, rgba(255,255,255,0) 58%),
            radial-gradient(ellipse at 66% 46%, rgba(129, 204, 255, 0.18) 0%, rgba(255,255,255,0) 54%);
          filter: blur(18px);
          opacity: 0.72;
          pointer-events: none;
        }
        .lp01-hero-shell::after {
          content: '';
          position: absolute;
          top: 34px;
          right: 0;
          width: 52%;
          height: 48%;
          background:
            radial-gradient(circle at 58% 32%, rgba(255, 221, 236, 0.28) 0%, rgba(255,255,255,0) 48%),
            radial-gradient(circle at 78% 54%, rgba(201, 229, 255, 0.22) 0%, rgba(255,255,255,0) 52%);
          filter: blur(14px);
          opacity: 0.72;
          pointer-events: none;
        }
        .lp01-hero-left {
          position: relative;
          z-index: 4;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 14px;
          padding: 4px 0 0;
          overflow: visible;
        }
        .lp01-hero-logo {
          display: inline-flex;
          align-items: center;
        }
        .lp01-hero-logo img {
          display: block;
          width: clamp(160px, 14vw, 260px);
          height: auto;
          filter: drop-shadow(0 10px 24px rgba(54, 110, 163, 0.1));
        }
        .lp01-hero-copy {
          position: relative;
          z-index: 5;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0;
          width: 100%;
          overflow: visible;
        }
        .lp01-hero-copy-line + .lp01-hero-copy-line {
          margin-top: 14px;
        }
        .lp01-hero-copy-line {
          display: inline-flex;
          align-items: center;
          min-height: 62px;
          padding: 14px 30px;
          border-radius: 16px;
          background: rgba(255,255,255,0.84);
          border: 1px solid rgba(219, 224, 246, 0.68);
          color: #16181f;
          font-size: 27px;
          font-family: "'Noto Serif JP', 'Noto Sans JP', serif";
          font-weight: 600;
          letter-spacing: 0.09em;
          line-height: 1.1;
          box-shadow: 0 14px 30px rgba(130, 139, 199, 0.08);
          backdrop-filter: blur(12px);
        }
        .hero-title {
          position: relative;
          z-index: 6;
          margin: 14px 0 30px;
          width: max-content;
          max-width: none;
          overflow: visible;
          transform: translate(-68px, -4px);
        }
        .hero-title-image {
          display: block;
          width: clamp(612px, 44.1vw, 684px);
          max-width: none;
          height: auto;
        }
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
        .lp01-hero-subcopy {
          margin: 0;
          color: #1f4697;
          font-size: 19px;
          font-weight: 600;
          letter-spacing: 0.045em;
          line-height: 1.55;
          max-width: none;
          white-space: nowrap;
        }
        .lp01-hero-visual {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          min-height: 100%;
          padding-top: 0;
          padding-right: 10px;
          transform: translate(14px, -10px);
        }
        .lp01-hero-visual::before {
          content: '';
          position: absolute;
          inset: auto auto 4% 6%;
          width: 38%;
          height: 22%;
          border-radius: 999px;
          background: radial-gradient(circle, rgba(176, 193, 255, 0.5) 0%, rgba(176, 193, 255, 0) 72%);
          filter: blur(22px);
          opacity: 0.45;
          pointer-events: none;
        }
        .lp01-hero-image-frame {
          position: relative;
          width: min(100%, 940px);
          margin-left: auto;
          padding: 4px;
          border-radius: 18px;
          background: rgba(255,255,255,0.78);
          border: 1px solid rgba(215, 217, 233, 0.9);
          box-shadow: 0 18px 40px rgba(120, 138, 187, 0.1);
        }
        .lp01-hero-image {
          display: block;
          width: 100%;
          height: auto;
          border-radius: 14px;
          box-shadow: 0 10px 26px rgba(107, 103, 161, 0.08);
        }
        .lp01-hero-mobile-chara,
        .lp01-hero-speech-bubble {
          display: none;
        }
        .lp01-sp-br {
          display: none;
        }
        .lp01-pc-br {
          display: inline;
        }
        .lp01-hero-speech-bubble {
          display: none;
        }
        .lp01-hero-cta-band {
          padding: 20px 34px 32px;
          border-radius: 0 0 34px 34px;
          background:
            linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 28%),
            linear-gradient(90deg, #f5f1ff 0%, #fff7fb 50%, #eef7ff 100%);
          border-top: 1px solid rgba(224, 210, 244, 0.32);
        }
        .lp01-hero-mobile-cta {
          display: none;
        }
        .lp01-hero-mobile-cta-button {
          min-height: 62px;
          width: 100%;
          border-radius: 22px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 0 18px;
          text-decoration: none;
        }
        .lp01-hero-mobile-cta-primary {
          background: linear-gradient(90deg, #c164b5 0%, #e2779f 100%);
          color: #fff;
          box-shadow: 0 12px 24px rgba(184, 88, 151, 0.15);
        }
        .lp01-hero-mobile-cta-secondary {
          background: linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(251,247,255,0.9) 100%);
          color: #92539d;
          border: 2px solid #d2a6db;
          box-shadow: 0 12px 24px rgba(145, 74, 166, 0.07);
        }
        .lp01-hero-mobile-cta-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: rgba(255,255,255,0.11);
          font-size: 15px;
          font-weight: 800;
          flex-shrink: 0;
        }
        .lp01-hero-mobile-cta-text {
          flex: 1;
          text-align: center;
          font-size: 20px;
          font-weight: 800;
          letter-spacing: -0.01em;
        }
        .lp01-hero-mobile-cta-secondary .lp01-hero-mobile-cta-text {
          font-weight: 700;
        }
        .lp01-hero-mobile-cta-arrow {
          font-size: 28px;
          line-height: 1;
          opacity: 0.78;
        }
        .lp01-hero-cta-buttons {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 24px;
          width: min(1080px, 100%);
          margin: 0 auto;
        }
        .lp01-hero-cta-primary,
        .lp01-hero-cta-secondary {
          min-height: 76px;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 0 24px;
          text-decoration: none;
          font-size: 22px;
          font-weight: 800;
          letter-spacing: -0.01em;
          box-shadow: 0 12px 24px rgba(184, 88, 151, 0.15);
        }
        .lp01-hero-cta-primary {
          background: linear-gradient(90deg, #c164b5 0%, #e2779f 100%);
          color: #fff;
        }
        .lp01-hero-cta-secondary {
          background: linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(251,247,255,0.9) 100%);
          color: #92539d;
          border: 2px solid #d2a6db;
        }
        .lp01-hero-cta-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: rgba(255,255,255,0.16);
          font-size: 28px;
          font-weight: 900;
          flex-shrink: 0;
        }
        .lp01-hero-cta-secondary .lp01-hero-cta-icon {
          border-radius: 16px;
          background: #fff;
          border: 2px solid #d2a6db;
        }
        .lp01-envelope {
          position: relative;
          display: inline-block;
          width: 30px;
          height: 22px;
          border: 2px solid currentColor;
          border-radius: 3px;
          box-sizing: border-box;
        }
        .lp01-envelope::before,
        .lp01-envelope::after {
          content: '';
          position: absolute;
          top: 6px;
          width: 16px;
          height: 2px;
          background: currentColor;
          border-radius: 999px;
          transform-origin: center;
        }
        .lp01-envelope::before {
          left: -1px;
          transform: rotate(34deg);
        }
        .lp01-envelope::after {
          right: -1px;
          transform: rotate(-34deg);
        }
        .lp01-final-cta-email-icon {
          display: inline-grid;
          place-items: center;
          width: 40px;
          height: 30px;
          background: transparent;
          border: none;
          color: #92539d;
          line-height: 1;
          flex-shrink: 0;
          margin-left: 8px;
        }
        .lp01-hero-cta-text {
          flex: 1;
          text-align: center;
        }
        .lp01-hero-cta-arrow {
          font-size: 34px;
          line-height: 1;
          flex-shrink: 0;
        }
        .lp01-sonnanaka-char-left,
        .lp01-sonnanaka-char-right {
          position: absolute;
          bottom: 0;
          height: 310px;
          width: auto;
          z-index: 2;
          pointer-events: none;
          user-select: none;
        }
        .lp01-sonnanaka-char-left {
          left: 0;
        }
        .lp01-sonnanaka-char-right {
          right: 0;
        }
        .lp01-flow-grid {
          display: grid;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 18px;
          align-items: start;
        }
        .lp01-usecase-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 26px;
        }
        @media (max-width: 960px) {
          .lp01-sonnanaka-char-left,
          .lp01-sonnanaka-char-right {
            height: 200px;
          }
        }
        @media (max-width: 640px) {
          .lp01-sonnanaka-char-left,
          .lp01-sonnanaka-char-right {
            height: 130px;
          }
          .lp01-flow-grid {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 960px) {
          .lp01-hero-section {
            padding: 14px 0 10px !important;
          }
          .lp01-hero,
          .lp01-grid-2,
          .lp01-grid-3,
          .lp01-comparison,
          .lp01-media-row,
          .lp01-audience-grid,
          .lp01-problem-circles,
          .lp01-issue-bubbles,
          .lp01-hurdle-grid,
          .lp01-attention-thumbs,
          .lp01-subscription-layout,
          .lp01-asset-layout,
          .lp01-brand-layout {
            grid-template-columns: 1fr;
          }
          .lp01-hero-stage {
            min-height: auto;
          }
          .lp01-hero {
            width: 100% !important;
            margin: 0 !important;
          }
          .lp01-hero-stage {
            margin: 0 10px;
            width: calc(100% - 20px);
          }
          .lp01-hero-shell {
            min-height: auto;
            padding: 16px 16px 14px;
            grid-template-columns: 1fr;
            gap: 12px;
          }
          .lp01-hero-cta-band {
            display: none;
          }
          .lp01-hero-logo img {
            width: 124px;
          }
          .lp01-hero-copy-line + .lp01-hero-copy-line {
            margin-top: 6px;
          }
          .lp01-hero-copy-line {
            min-height: 46px;
            font-size: clamp(19px, 5.6vw, 25px);
            padding: 8px 16px;
            border-radius: 14px;
            letter-spacing: 0.055em;
            font-weight: 500;
          }
          .hero-title {
            margin: 12px 0 12px;
            width: 100%;
            max-width: 100%;
            transform: none;
          }
          .hero-title-image {
            width: min(100%, 340px);
            max-width: 100%;
          }
          .lp01-hero-subcopy {
            margin-top: 0 !important;
            max-width: none !important;
            width: 100% !important;
            font-size: 15px !important;
            line-height: 1.6 !important;
            white-space: normal !important;
          }
          .lp01-hero-mobile-cta {
            position: relative;
            z-index: 4;
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
            width: 100%;
            margin-bottom: -4px;
          }
          .lp01-hero-visual {
            justify-content: center;
            align-items: center;
            padding-right: 0;
            transform: none;
          }
          .lp01-hero-visual::before {
            display: none;
          }
          .lp01-hero-image-frame {
            width: 100%;
            padding: 3px;
            border-radius: 18px;
          }
          .lp01-hero-image {
            border-radius: 15px;
          }
          .lp01-audience-grid,
          .lp01-problem-circles {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
          .lp01-audience-grid {
            gap: 10px 6px !important;
            width: calc(100% + 24px) !important;
            margin-left: -12px !important;
            margin-right: -12px !important;
          }
          .lp01-audience-item {
            min-height: 42px !important;
            font-size: 14px !important;
            padding: 0 6px !important;
            white-space: nowrap !important;
          }
          .lp01-problem-circles {
            gap: 18px !important;
          }
          .lp01-problem-circle {
            width: 100% !important;
            min-height: 232px !important;
            padding: 10px 12px 12px !important;
            border-width: 2px !important;
          }
          .lp01-problem-circle img {
            width: 78px !important;
            height: 78px !important;
            object-fit: contain !important;
            margin: 0 auto 6px !important;
            border-radius: 0 !important;
          }
          .lp01-problem-title {
            font-size: 14px !important;
            line-height: 1.55 !important;
            letter-spacing: -0.02em !important;
          }
          .lp01-subscription-note {
            font-size: 18px !important;
            white-space: nowrap !important;
          }
          .lp01-subscription-box {
            padding: 20px 16px 24px !important;
          }
          .lp01-subscription-banner {
            font-size: 18px !important;
            padding: 0 12px !important;
          }
          .lp01-subscription-figure {
            min-height: auto !important;
            text-align: center !important;
          }
          .lp01-subscription-figure img {
            width: min(100%, 280px) !important;
            margin: 0 auto !important;
          }
          .lp01-subscription-copy {
            min-height: auto !important;
            margin-top: 8px !important;
          }
          .lp01-subscription-copy-inner {
            width: 100% !important;
            text-align: center !important;
            justify-items: center !important;
          }
          .lp01-hero-cta-buttons {
            grid-template-columns: 1fr;
          }
          .lp01-hero-cta-primary,
          .lp01-hero-cta-secondary {
            min-height: 88px;
            font-size: 19px;
            padding: 0 24px;
          }
          .lp01-issue-container {
            min-height: 520px !important;
            margin-bottom: -80px !important;
          }
          .lp01-issue-dark-arrow {
            display: none;
          }
          .lp01-issue-dark-title {
            white-space: nowrap;
          }
          .lp01-issue-dark-row {
            display: flex !important;
            justify-content: center;
            width: 100%;
            gap: 16px !important;
          }
          .lp01-issue-dark-bracket {
            font-size: 48px !important;
          }
          .lp01-sonnanaka-card {
            width: calc(100% - 32px) !important;
            padding: 56px 20px 34px !important;
          }
          .lp01-sonnanaka-desc {
            font-size: 15px !important;
          }
          .lp01-sp-br {
            display: inline !important;
          }
          .lp01-pc-br {
            display: none !important;
          }
          .lp01-sonnanaka-container {
            min-height: 360px !important;
            /* スマホ：セクションを縦に広げてキャラクターを1cm下げる */
            padding-bottom: 95px !important;
          }
          .lp01-attention-outer {
            padding: 26px 16px 24px !important;
            min-height: 340px !important;
          }
          .lp01-attention-char-wrap {
            width: clamp(140px, 39.2%, 224px) !important;
            bottom: 184px !important;
            z-index: 3 !important;
          }
          .lp01-attention-hero-wrap {
            display: none !important;
          }
          .lp01-attention-card {
            width: calc(100% - 32px) !important;
            margin-top: 138px !important;
            top: 0 !important;
          }
          .lp01-header-inner {
            flex-wrap: nowrap !important;
            gap: 8px !important;
            min-height: 52px !important;
            padding: 6px 16px !important;
          }
          .lp01-header-logo-img {
            height: 40px !important;
          }
          .lp01-header-buttons {
            flex-wrap: nowrap !important;
            gap: 6px !important;
          }
          .lp01-header-btn {
            min-height: 36px !important;
            padding: 0 12px !important;
            font-size: 13px !important;
            white-space: nowrap;
          }
          .lp01-subscrip-outer {
            padding: 46px 16px 34px !important;
          }
          .lp01-subscrip-card {
            padding: 44px 16px 34px !important;
          }
          .lp01-subscrip-badge {
            white-space: nowrap;
            font-size: 15px !important;
            padding: 0 16px !important;
          }
          .lp01-subscrip-h3 {
            font-size: clamp(24px, 6.5vw, 34px) !important;
          }
          .lp01-flow-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .lp01-flow-step-header {
            min-height: 52px !important;
            padding: 10px 16px !important;
            border-radius: 0 28px 28px 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
          }
          .lp01-flow-step-header-inner {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
          }
          .lp01-flow-step-header-inner h3 {
            margin: 0 !important;
            font-size: 17px !important;
          }
          .lp01-flow-step-content {
            display: flex !important;
            align-items: flex-start !important;
            gap: 14px !important;
            margin-top: 14px !important;
          }
          .lp01-flow-step-icon {
            width: 86px !important;
            height: 86px !important;
            margin: 0 !important;
            flex-shrink: 0 !important;
          }
          .lp01-flow-step-icon img {
            width: 76px !important;
            height: 76px !important;
          }
          .lp01-flow-step-body {
            margin: 0 !important;
            font-size: 14px !important;
            flex: 1 !important;
          }
          .lp01-sonnanaka-char-left,
          .lp01-sonnanaka-char-right {
            position: absolute !important;
            display: block !important;
            height: 210px !important;
            width: auto !important;
            bottom: 0 !important;
            object-fit: contain !important;
            object-position: bottom !important;
            vertical-align: unset !important;
          }
          .lp01-sonnanaka-char-left {
            left: -4px !important;
            right: auto !important;
          }
          .lp01-sonnanaka-char-right {
            right: -4px !important;
            left: auto !important;
          }
          .lp01-issue-title-banner {
            font-size: 18px !important;
            padding: 10px 22px !important;
            white-space: nowrap;
            top: 22px !important;
          }
          .lp01-issue-arrow-down {
            top: 56px !important;
          }
          .lp01-issue-figure {
            position: absolute !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            bottom: 75px !important;
            width: 52% !important;
            max-width: 210px !important;
            height: 300px !important;
            margin: 0 !important;
          }
          .lp01-issue-bubbles {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            width: 100% !important;
            height: 100% !important;
            display: block !important;
            margin: 0 !important;
          }
          .lp01-issue-bubble.large {
            position: absolute !important;
            left: 3% !important;
            top: calc(50% - 75px) !important;
            transform: translateY(-50%) !important;
            width: 128px !important;
            height: 128px !important;
            font-size: 12px !important;
            padding: 12px !important;
            justify-self: unset !important;
            align-self: unset !important;
          }
          .lp01-issue-bubble.small {
            position: absolute !important;
            right: calc(3% + 38px) !important;
            top: 126px !important;
            left: auto !important;
            width: 108px !important;
            height: 108px !important;
            font-size: 12px !important;
            padding: 12px !important;
            justify-self: unset !important;
          }
          .lp01-issue-bubble.bottom {
            position: absolute !important;
            right: 3% !important;
            bottom: 137px !important;
            left: auto !important;
            top: auto !important;
            width: 108px !important;
            height: 108px !important;
            font-size: 12px !important;
            padding: 12px !important;
            margin: 0 !important;
            justify-self: unset !important;
          }
          .lp01-answer-figure {
            position: relative;
            width: 260px;
            height: 280px;
            margin: 16px auto 0;
            left: auto !important;
            right: auto !important;
          }
          .lp01-attention-figure {
            position: relative;
            left: auto;
            bottom: auto;
            width: 280px;
            height: 350px;
            margin: 24px auto 0;
          }
          .lp01-attention-thumbs {
            position: relative;
            top: auto;
            right: auto;
            width: 100%;
            margin-top: 24px;
          }
          .lp01-attention-arrow {
            position: relative;
            top: auto;
            left: auto;
            transform: none;
            margin: 18px auto;
          }
          main > section {
            padding-top: 14px !important;
          }
          main > section + section {
            margin-top: -56px !important;
          }
          .lp01-problem-circles,
          .lp01-subscription-layout,
          .lp01-usecase-grid,
          .lp01-flow-grid,
          .lp01-cta-row {
            margin-top: 16px !important;
          }
          .lp01-cta-row {
            grid-template-columns: 1fr !important;
          }
          .lp01-flow-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
          }
          .lp01-usecase-grid {
            grid-template-columns: 1fr;
          }
          .lp01-final-cta-container {
            min-height: 380px !important;
          }
          .lp01-final-cta-logo {
            left: 4px !important;
          }
          .lp01-final-cta-circle {
            display: grid !important;
            left: auto !important;
            right: 12px !important;
            top: 88px !important;
            width: 90px !important;
            height: 90px !important;
            font-size: 12px !important;
          }
          .lp01-final-cta-chara {
            width: 70% !important;
            left: -19px !important;
            bottom: 38px !important;
          }
          .lp01-final-cta-text {
            right: -54px !important;
            left: auto !important;
            top: auto !important;
            bottom: 96px !important;
            gap: 8px !important;
          }
          .lp01-final-cta-text > div {
            font-size: clamp(26px, 7.2vw, 38px) !important;
            padding: 7px 14px !important;
          }
          .lp01-final-cta-desc {
            font-size: 18px !important;
          }
          .lp01-final-cta-email-icon {
            width: 36px !important;
            height: 28px !important;
          }
          .lp01-final-cta-email-icon .lp01-envelope,
          .lp01-hero-cta-secondary .lp01-hero-cta-icon .lp01-envelope {
            width: 30px !important;
            height: 21px !important;
            border-width: 3px !important;
          }
          .lp01-why-char {
            height: 48% !important;
            max-height: 240px !important;
          }
          .lp01-why-bg {
            min-height: 480px !important;
          }
        }
      `}</style>

      <header
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 30,
          background: 'linear-gradient(90deg, rgba(247,238,251,0.92) 0%, rgba(245,247,255,0.92) 50%, rgba(238,248,255,0.92) 100%)',
          backdropFilter: 'blur(14px)',
          borderBottom: '1px solid rgba(24,53,43,0.08)',
          opacity: showStickyHeader ? 1 : 0,
          transform: showStickyHeader ? 'translateY(0)' : 'translateY(-100%)',
          pointerEvents: showStickyHeader ? 'auto' : 'none',
          transition: 'opacity 0.28s ease, transform 0.28s ease',
        }}
      >
        <div className="lp01-header-inner" style={{ ...shellStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', minHeight: 72, padding: '10px 0' }}>
          <a href="/" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <img className="lp01-header-logo-img" src="/nuntlogo.png" alt="Nunt" style={{ height: 72, width: 'auto' }} />
          </a>
          <div className="lp01-header-buttons" style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <a className="lp01-header-btn" href="/download" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minHeight: 46, padding: '0 22px', borderRadius: 18, background: 'linear-gradient(90deg, #c164b5 0%, #e2779f 100%)', color: '#fff', fontWeight: 800, textDecoration: 'none', boxShadow: '0 6px 16px rgba(184, 88, 151, 0.14)' }}>
              資料ダウンロード
            </a>
            <a className="lp01-header-btn" href="/contact" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minHeight: 46, padding: '0 22px', borderRadius: 18, background: 'rgba(255,255,255,0.92)', color: '#92539d', fontWeight: 800, textDecoration: 'none', border: '2px solid #d2a6db', boxShadow: '0 6px 16px rgba(145, 74, 166, 0.07)' }}>
              無料で相談する
            </a>
          </div>
        </div>
      </header>

      <main>
        <section
          className="lp01-hero-section"
          ref={heroSectionRef}
          style={{
            padding: '30px 0 16px',
            background: 'linear-gradient(90deg, #f7eefb 0%, #f5f7ff 50%, #eef8ff 100%)',
          }}
        >
          <div
            className="lp01-hero"
            style={{
              width: 'min(calc(100vw - 32px), 1720px)',
              margin: '0 auto',
            }}
          >
            <div className="lp01-hero-stage">
              <div className="lp01-hero-shell">
                <div className="lp01-hero-left">
                  <div className="lp01-hero-logo">
                    <img src="/nuntlogo.png" alt="Nunt" />
                  </div>
                  <div className="lp01-hero-copy">
                    <div className="lp01-hero-copy-line">タレント活用で</div>
                    <div className="lp01-hero-copy-line">第一印象を変え</div>
                    <h1 className="hero-title">
                      <span className="sr-only">来院につなげる</span>
                      <img
                        src="/images/hero-title-raiin-transparent.png"
                        alt=""
                        aria-hidden="true"
                        className="hero-title-image"
                      />
                    </h1>
                    <p className="lp01-hero-subcopy">
                      タイで事業を展開する企業向けのタレント活用サービス
                    </p>
                  </div>
                </div>

                <div className="lp01-hero-mobile-cta">
                  <a href="/download" className="lp01-hero-mobile-cta-button lp01-hero-mobile-cta-primary">
                    <span className="lp01-hero-mobile-cta-badge">無料</span>
                    <span className="lp01-hero-mobile-cta-text">資料ダウンロード</span>
                    <span className="lp01-hero-mobile-cta-arrow">›</span>
                  </a>
                  <a href="/contact" className="lp01-hero-mobile-cta-button lp01-hero-mobile-cta-secondary">
                    <span className="lp01-final-cta-email-icon" aria-hidden="true">
                      <span className="lp01-envelope" />
                    </span>
                    <span className="lp01-hero-mobile-cta-text">無料で相談する</span>
                    <span className="lp01-hero-mobile-cta-arrow">›</span>
                  </a>
                </div>

                <div className="lp01-hero-visual">
                  <div className="lp01-hero-image-frame">
                    <img
                      className="lp01-hero-image"
                      src="/lp01-hero-clinic-site-only.png"
                      alt="タレントを起用した美容クリニックWebサイトのイメージ"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="lp01-hero-cta-band">
              <div
                className="lp01-cta-row"
                style={{
                  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                  gap: 26,
                  alignItems: 'stretch',
                }}
              >
                <a
                  href="/download"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 76,
                    padding: '0 24px',
                    borderRadius: 30,
                    background: 'linear-gradient(90deg, #c164b5 0%, #e2779f 100%)',
                    color: '#fff',
                    textDecoration: 'none',
                    boxShadow: '0 12px 24px rgba(184, 88, 151, 0.15)',
                  }}
                >
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: '50%', background: 'rgba(255,255,255,0.11)', fontSize: 18, fontWeight: 800 }}>
                    無料
                  </span>
                  <span style={{ fontSize: 'clamp(21px, 2vw, 30px)', fontWeight: 800, letterSpacing: '-0.01em' }}>資料ダウンロード</span>
                  <span style={{ fontSize: 30, lineHeight: 1, opacity: 0.84 }}>›</span>
                </a>

                <a
                  href="/contact"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 76,
                    padding: '0 24px',
                    borderRadius: 30,
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(251,247,255,0.9) 100%)',
                    color: '#92539d',
                    textDecoration: 'none',
                    border: '2px solid #d2a6db',
                    boxShadow: '0 12px 24px rgba(145, 74, 166, 0.07)',
                  }}
                >
                  <span className="lp01-final-cta-email-icon" aria-hidden="true">
                    <span className="lp01-envelope" />
                  </span>
                  <span style={{ fontSize: 'clamp(21px, 1.9vw, 29px)', fontWeight: 700, letterSpacing: '-0.01em' }}>無料で相談する</span>
                  <span style={{ fontSize: 30, lineHeight: 1, opacity: 0.68 }}>›</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '58px 0 0' }}>
          <div style={shellStyle}>
            <div style={{ borderRadius: 34, overflow: 'hidden', boxShadow: '0 24px 70px rgba(112, 73, 182, 0.12)' }}>
              <div style={{ background: '#a167da', padding: '42px 32px 34px', color: '#fff', textAlign: 'center' }}>
                <h2 style={{ margin: 0, fontSize: 'clamp(28px, 4vw, 50px)', lineHeight: 1.15, letterSpacing: '-0.03em' }}>
                  医療・美容業界の方必見
                </h2>
                <div className="lp01-audience-grid" style={{ width: 'min(1000px, 100%)', margin: '28px auto 0' }}>
                  {audienceTags.map((item) => (
                    <div
                      key={item}
                      className="lp01-audience-item"
                      style={{
                        background: 'rgba(255,255,255,0.96)',
                        color: '#8c5ac6',
                        minHeight: 48,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 18,
                        fontWeight: 700,
                        borderRadius: 2,
                        boxShadow: '0 10px 22px rgba(88, 49, 147, 0.08)',
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
                <p style={{ margin: '12px 0 0', textAlign: 'right', fontSize: 18, opacity: 0.9 }}>etc.</p>
              </div>

              <div
                style={{
                  padding: '54px 28px 44px',
                  background:
                    'radial-gradient(circle at center, rgba(255, 226, 244, 0.52), transparent 26%), linear-gradient(180deg, rgba(250,247,255,0.98) 0%, rgba(252,249,255,0.98) 100%)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'repeating-linear-gradient(150deg, rgba(157, 143, 214, 0.08) 0 2px, transparent 2px 12px)',
                    opacity: 0.45,
                    pointerEvents: 'none',
                  }}
                />
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <h3
                    style={{
                      margin: 0,
                      textAlign: 'center',
                      color: '#a167da',
                      fontSize: 'clamp(28px, 4vw, 50px)',
                      lineHeight: 1.2,
                      letterSpacing: '-0.03em',
                    }}
                  >
                    こんなお悩みありませんか？
                  </h3>

                  <div className="lp01-problem-circles" style={{ width: 'min(1180px, 100%)', margin: '44px auto 0' }}>
                    {commonProblems.map((item, index) => (
                      <div key={item.title} className="lp01-problem-circle">
                        {index === 0 ? (
                          <img
                            src="/problem-local-customer.png"
                            alt="地域のお客様が大手に流れてしまう"
                            style={{ width: '100%', height: 'auto', marginBottom: 10, borderRadius: 12 }}
                          />
                        ) : index === 1 ? (
                          <img
                            src="/problem-no-repeat.png"
                            alt="新規が来てもリピーターが定着しない"
                            style={{ width: '100%', height: 'auto', marginBottom: 10, borderRadius: 12 }}
                          />
                        ) : index === 2 ? (
                          <img
                            src="/problem-sns-repeat.png"
                            alt="SNSもやっているが似たような投稿ばかり"
                            style={{ width: '100%', height: 'auto', marginBottom: 10, borderRadius: 12 }}
                          />
                        ) : (
                          <img
                            src="/problem-staff-shortage.png"
                            alt="スタッフの採用が難しくずっと人手不足"
                            style={{ width: '100%', height: 'auto', marginBottom: 10, borderRadius: 12 }}
                          />
                        )}
                        <p className="lp01-problem-title">
                          {index === 0 ? (
                            <>
                              地域のお客様が
                              <br />
                              <span className="lp01-problem-emphasis">大手に流れてしまう</span>
                            </>
                          ) : index === 1 ? (
                            <>
                              新規が来ても
                              <br />
                              <span className="lp01-problem-emphasis">リピーターが定着しない</span>
                            </>
                          ) : index === 2 ? (
                            <>
                              <span className="lp01-problem-emphasis">SNS</span>もやっているが
                              <br />
                              似たような投稿ばかり
                            </>
                          ) : (
                            <>
                              スタッフの採用が
                              <br />
                              難しくずっと
                              <span className="lp01-problem-emphasis"> 人手不足</span>
                            </>
                          )}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div style={{ borderRadius: 34, overflow: 'hidden', boxShadow: '0 24px 70px rgba(10,38,31,0.12)' }}>
              <div
                className="lp01-issue-container"
                style={{
                  position: 'relative',
                  minHeight: 540,
                  background: 'linear-gradient(90deg, #e6e1f8 0%, #ffffff 18%, #ffffff 82%, #e6e1f8 100%)',
                  overflow: 'hidden',
                }}
              >
                <div
                  className="lp01-issue-title-banner"
                  style={{
                    position: 'absolute',
                    top: 38,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#a167da',
                    color: '#fff',
                    padding: '14px 44px',
                    fontSize: 28,
                    fontWeight: 900,
                    lineHeight: 1.2,
                    letterSpacing: '-0.03em',
                    zIndex: 3,
                  }}
                >
                  競争が激化している中で
                </div>
                <div
                  className="lp01-issue-arrow-down"
                  style={{
                    position: 'absolute',
                    top: 92,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '12px solid transparent',
                    borderRight: '12px solid transparent',
                    borderTop: '18px solid #a167da',
                    zIndex: 3,
                  }}
                />

                <div className="lp01-issue-figure">
                  <img
                    src="/person-doctor-thinking.png"
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'bottom center' }}
                  />
                </div>

                <div className="lp01-issue-bubbles">
                  <div className="lp01-issue-bubble large">
                    クリニック・
                    <br />
                    サロンのことを
                    <br />
                    覚えてもらえない
                  </div>
                  <div className="lp01-issue-bubble small">
                    競合が多くて
                    <br />
                    認知されない
                  </div>
                  <div className="lp01-issue-bubble bottom">
                    他社と差別化
                    <br />
                    できない
                  </div>
                </div>
              </div>

              <div
                style={{
                  position: 'relative',
                  background: 'linear-gradient(135deg, #2a2a2a 0%, #121212 100%)',
                  color: '#fff',
                  textAlign: 'center',
                  padding: '44px 24px 54px',
                }}
              >
                <div
                  className="lp01-issue-dark-arrow"
                  style={{
                    position: 'absolute',
                    top: -22,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '22px solid transparent',
                    borderRight: '22px solid transparent',
                    borderTop: '22px solid #fff',
                  }}
                />
                <p style={{ margin: 0, fontSize: 22, color: 'rgba(255,255,255,0.9)' }}>これらが</p>
                <div className="lp01-issue-dark-row" style={{ display: 'inline-flex', alignItems: 'center', gap: 34, marginTop: 10 }}>
                  <span className="lp01-issue-dark-bracket" style={{ fontSize: 76, lineHeight: 1, color: 'rgba(255,255,255,0.65)' }}>［</span>
                  <h2 className="lp01-issue-dark-title" style={{ margin: 0, fontSize: 'clamp(24px, 3.2vw, 44px)', lineHeight: 1.1, letterSpacing: '-0.05em' }}>
                    深刻な課題に！
                  </h2>
                  <span className="lp01-issue-dark-bracket" style={{ fontSize: 76, lineHeight: 1, color: 'rgba(255,255,255,0.65)' }}>］</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div style={{ borderRadius: 34, overflow: 'hidden', boxShadow: '0 24px 70px rgba(128, 119, 192, 0.12)' }}>
              <div
                className="lp01-sonnanaka-container"
                style={{
                  position: 'relative',
                  minHeight: 360,
                  background: 'linear-gradient(180deg, #efe3ff 0%, #d8f0ef 100%)',
                  padding: '34px 28px 0',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 20,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#a167da',
                    color: '#fff',
                    padding: '10px 36px',
                    fontSize: 24,
                    fontWeight: 900,
                    lineHeight: 1.2,
                    zIndex: 3,
                  }}
                >
                  そんな中
                </div>
                <div
                  style={{
                    position: 'absolute',
                    top: 68,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                    borderTop: '16px solid #a167da',
                    zIndex: 3,
                  }}
                />

                <div
                  className="lp01-sonnanaka-card"
                  style={{
                    position: 'relative',
                    zIndex: 2,
                    width: 'min(960px, calc(100% - 180px))',
                    margin: '0 auto',
                    background: 'rgba(255,255,255,0.94)',
                    padding: '56px 40px 34px',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#333' }}>大手企業が使うのは</p>
                  <h2 style={{ margin: '10px 0 0', fontSize: 'clamp(24px, 3.2vw, 44px)', lineHeight: 1.18, letterSpacing: '-0.04em', color: '#222' }}>
                    <span style={{ color: '#a167da' }}>「信頼感のある素材」</span>を活用した
                    <br />
                    認知度UP施策
                  </h2>
                  <p className="lp01-sonnanaka-desc" style={{ margin: '18px 0 0', fontSize: 18, lineHeight: 1.8, color: '#444' }}>
                    「あのお店、見たことある」と<br className="lp01-sp-br" />認知されることで<br className="lp01-pc-br" />集客や<br className="lp01-sp-br" />検討につながり<br className="lp01-sp-br" />やすくなります
                  </p>
                </div>

                <img src="/chibi-clipboard.png" alt="" className="lp01-sonnanaka-char-left" />
                <img src="/chibi-glasses.png" alt="" className="lp01-sonnanaka-char-right" />

              </div>

              <div
                style={{
                  background: 'linear-gradient(90deg, #ead8f4 0%, #dce8fb 50%, #f0dff3 100%)',
                  padding: '36px 24px 46px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    display: 'inline-flex',
                    padding: '8px 28px',
                    background: '#2d2d2d',
                    color: '#fff',
                    fontSize: 24,
                    fontWeight: 800,
                    lineHeight: 1.2,
                    marginBottom: 16,
                  }}
                >
                  でも…
                </div>
                <h3 style={{ margin: 0, fontSize: 'clamp(26px, 3.2vw, 48px)', lineHeight: 1.2, letterSpacing: '-0.03em' }}>
                  <span style={{ color: '#a167da' }}>タレント起用</span>はハードルが高い
                </h3>
                <div
                  style={{
                    width: 'min(820px, 100%)',
                    margin: '28px auto 0',
                    background: 'rgba(255,255,255,0.92)',
                    border: '2px solid rgba(180, 113, 218, 0.42)',
                    borderRadius: 24,
                    padding: '32px 28px',
                    boxShadow: '0 18px 44px rgba(163, 121, 215, 0.08)',
                  }}
                >
                  <div className="lp01-hurdle-grid">
                    {[
                      { title: '高額なコスト', img: '/hurdle-cost.png' },
                      { title: '複雑な契約手続き', img: '/hurdle-contract.png' },
                      { title: '撮影関係のリソース', img: '/hurdle-shooting.png' },
                    ].map(({ title, img, label, bg }) => (
                      <div key={title} className="lp01-hurdle-card">
                        <div className="lp01-hurdle-image" style={{ background: img ? 'none' : bg, padding: img ? 0 : undefined, overflow: 'hidden' }}>
                          {img ? <img src={img} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: 6 }} /> : label}
                        </div>
                        <p className="lp01-hurdle-caption">{title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              className="lp01-attention-outer"
              style={{
                position: 'relative',
                borderRadius: 34,
                overflow: 'hidden',
                background: 'linear-gradient(180deg, #faf7ff 0%, #f0f8ff 30%, #bfe8ff 60%, #d6f3ff 100%)',
                boxShadow: '0 24px 70px rgba(128, 179, 216, 0.12)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '52px 24px 80px',
              }}
            >
              {/* 左側：キャラクター画像（絶対配置）*/}
              <div
                className="lp01-attention-char-wrap"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: 'clamp(140px, 22%, 320px)',
                  pointerEvents: 'none',
                  zIndex: 1,
                }}
              >
                <img
                  src="/sonnanaka-chara.png"
                  alt=""
                  style={{ width: '100%', display: 'block' }}
                />
              </div>

              {/* 右側：バナー画像（絶対配置）*/}
              <div
                className="lp01-attention-hero-wrap"
                style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  right: 0,
                  width: 'clamp(220px, 32%, 420px)',
                  overflow: 'visible',
                  pointerEvents: 'none',
                  zIndex: 1,
                }}
              >
                <img
                  src="/sonnanaka-hero.png"
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', display: 'block' }}
                />
              </div>
              {/* 見出し */}
              <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#222', letterSpacing: '-0.03em', textAlign: 'center', position: 'relative', zIndex: 2 }}>
                そこで今<span style={{ color: '#a167da', fontSize: 'clamp(24px, 3.2vw, 44px)', fontWeight: 900 }}>注目されている</span>のが
              </p>

              {/* 下矢印 */}
              <div style={{ width: 0, height: 0, borderLeft: '12px solid transparent', borderRight: '12px solid transparent', borderTop: '18px solid #a167da', margin: '16px 0', position: 'relative', zIndex: 2 }} />

              {/* メインカード */}
              <div className="lp01-attention-card" style={{ width: 'min(480px, 60%)', position: 'relative', paddingTop: 0, marginTop: 80, marginBottom: 0, top: 60, zIndex: 2 }}>
                {/* 低コストバッジ */}
                <div
                  style={{
                    position: 'absolute',
                    top: -123,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 154,
                    height: 154,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.97)',
                    border: '3px solid #69b9e5',
                    display: 'grid',
                    placeItems: 'center',
                    textAlign: 'center',
                    color: '#58a6d7',
                    fontWeight: 900,
                    boxShadow: '0 12px 28px rgba(88, 166, 215, 0.15)',
                    zIndex: 2,
                  }}
                >
                  <div style={{ fontSize: 19, lineHeight: 1.35 }}>
                    低コスト
                    <br />
                    <span style={{ fontSize: 14 }}>で始められる</span>
                  </div>
                </div>

                {/* カード本体 */}
                <div
                  style={{
                    background: 'linear-gradient(180deg, #67b4df 0%, #59a9d7 100%)',
                    borderRadius: 20,
                    padding: '36px 28px 36px',
                    boxShadow: '0 16px 32px rgba(75, 156, 208, 0.2)',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ margin: 0, color: '#fff', fontSize: 18, fontWeight: 700 }}>
                    月額固定で素材使い放題
                  </p>
                  <div
                    style={{
                      marginTop: 18,
                      background: 'rgba(255,255,255,0.96)',
                      padding: '21px 24px',
                      color: '#9a5bd0',
                      fontSize: 'clamp(24px, 3.2vw, 44px)',
                      fontWeight: 900,
                      letterSpacing: '-0.04em',
                      borderRadius: 12,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    新しいタレント起用
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div style={{ borderRadius: 34, overflow: 'hidden', boxShadow: '0 24px 70px rgba(132, 176, 228, 0.12)' }}>
              <div style={{ background: '#fff', padding: '34px 24px 24px', textAlign: 'center' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 56,
                    padding: '0 28px',
                    border: '2px solid rgba(60,60,60,0.42)',
                    fontSize: 18,
                    fontWeight: 700,
                    color: '#2b2b2b',
                  }}
                >
                  なぜ？大手企業でなくても
                </div>
                <h2 style={{ margin: '24px 0 0', fontSize: 'clamp(24px, 3.2vw, 44px)', lineHeight: 1.18, letterSpacing: '-0.04em', color: '#222' }}>
                  <span style={{ color: '#68b9e6' }}>タレントプロモーション</span>が可能なのか？
                </h2>
              </div>

              <div
                className="lp01-why-bg"
                style={{
                  position: 'relative',
                  minHeight: 560,
                  background: 'linear-gradient(180deg, #71c6f3 0%, #86cff8 45%, #7fd0ff 100%)',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    width: '70%',
                    height: '72%',
                    background: 'linear-gradient(135deg, #9f8ae9 0%, #b29af0 100%)',
                    clipPath: 'polygon(0 16%, 100% 68%, 100% 100%, 0 100%)',
                    opacity: 0.95,
                  }}
                />

                {/* 左キャラクター（メガネ・案内ポーズ） */}
                <img
                  src={charGuide}
                  alt=""
                  className="lp01-why-char lp01-why-char-left"
                  style={{
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    height: '92%',
                    maxHeight: 520,
                    objectFit: 'contain',
                    objectPosition: 'bottom left',
                    zIndex: 5,
                  }}
                />

                {/* 右キャラクター（指差しポーズ） */}
                <img
                  src={charPoint}
                  alt=""
                  className="lp01-why-char lp01-why-char-right"
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    height: '92%',
                    maxHeight: 520,
                    objectFit: 'contain',
                    objectPosition: 'bottom right',
                    zIndex: 5,
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    top: 32,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 1,
                    height: 92,
                    background: 'rgba(70,70,70,0.7)',
                    zIndex: 3,
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    top: 86,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#2d2d2d',
                    color: '#fff',
                    padding: '10px 28px',
                    fontSize: 24,
                    fontWeight: 800,
                    lineHeight: 1.2,
                    zIndex: 4,
                  }}
                >
                  答えは…
                </div>


                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: 118,
                    transform: 'translateX(-50%)',
                    width: 'min(590px, 80%)',
                    zIndex: 3,
                  }}
                >
                  <div
                    style={{
                      borderRadius: 22,
                      background: 'linear-gradient(135deg, rgba(79, 224, 193, 0.72) 0%, rgba(198, 96, 239, 0.72) 100%)',
                      padding: 8,
                      boxShadow: '0 24px 44px rgba(100, 145, 216, 0.16)',
                    }}
                  >
                    <div style={{ background: 'rgba(255,255,255,0.95)', borderRadius: 18, padding: '18px 18px 24px' }}>
                      <div className="lp01-answer-lines">
                        <div style={{ height: 3, background: 'linear-gradient(90deg, rgba(79,224,193,0.72), rgba(79,224,193,0.1))', borderRadius: 999 }} />
                        <div style={{ height: 3, background: 'linear-gradient(90deg, rgba(198,96,239,0.1), rgba(198,96,239,0.72))', borderRadius: 999 }} />
                      </div>
                      <div
                        style={{
                          marginTop: 22,
                          textAlign: 'center',
                          color: '#d35be5',
                          fontSize: 'clamp(24px, 3.2vw, 44px)',
                          fontWeight: 900,
                          letterSpacing: '-0.06em',
                          lineHeight: 1.2,
                        }}
                      >
                        “タレントサブスク”
                        <br />
                        サービス
                      </div>
                      <div className="lp01-answer-lines" style={{ marginTop: 22 }}>
                        <div style={{ height: 3, background: 'linear-gradient(90deg, rgba(79,224,193,0.72), rgba(79,224,193,0.1))', borderRadius: 999 }} />
                        <div style={{ height: 3, background: 'linear-gradient(90deg, rgba(198,96,239,0.1), rgba(198,96,239,0.72))', borderRadius: 999 }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              className="lp01-subscrip-outer"
              style={{
                background: '#e6f6ff',
                borderRadius: 34,
                padding: '46px 28px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <h2 style={{ margin: 0, fontSize: 'clamp(24px, 3.2vw, 44px)', lineHeight: 1.15, color: '#67b8e5', letterSpacing: '-0.04em' }}>
                  「タレントサブスク」は
                </h2>
                <div style={{ width: 'min(820px, 100%)', height: 2, background: '#8dcdf1', margin: '18px auto 0' }} />
                <p style={{ margin: '20px auto 0', maxWidth: 860, fontSize: 18, lineHeight: 1.85, color: '#333' }}>
                  大手企業の専売特許だったタレント起用を、どんな企業でも活用できるようにした画期的なサービスです。
                </p>
              </div>

              <div
                className="lp01-subscrip-card"
                style={{
                  width: 'min(980px, 100%)',
                  margin: '34px auto 0',
                  background: '#fff',
                  borderRadius: 28,
                  padding: '44px 30px 34px',
                  boxShadow: '0 20px 44px rgba(130, 180, 216, 0.12)',
                  position: 'relative',
                }}
              >
                <div
                  className="lp01-subscrip-badge"
                  style={{
                    position: 'absolute',
                    top: -22,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#55aee0',
                    color: '#fff',
                    minHeight: 44,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 24px',
                    fontSize: 18,
                    fontWeight: 800,
                  }}
                >
                  サブスクサービスだから
                </div>

                <div style={{ textAlign: 'center' }}>
                  <h3 className="lp01-subscrip-h3" style={{ margin: 0, fontSize: 'clamp(34px, 4vw, 58px)', lineHeight: 1.18, color: '#222', letterSpacing: '-0.03em' }}>
                    コストを抑えて導入可能
                  </h3>
                  <p style={{ margin: '14px 0 0', fontSize: 18, lineHeight: 1.8, color: '#444' }}>
                    従来のタレント起用に比べてリーズナブルな料金でプロモーションを展開できます。
                  </p>
                </div>

                <div
                  className="lp01-subscription-box"
                  style={{
                    marginTop: 28,
                    background: '#eaf6ff',
                    borderRadius: 24,
                    padding: '26px 28px 30px',
                  }}
                >
                  <div
                    className="lp01-subscription-banner"
                    style={{
                      minHeight: 46,
                      border: '2px solid rgba(60,60,60,0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontSize: 20,
                      fontWeight: 800,
                      color: '#333',
                    }}
                  >
                    月額固定で使い放題！
                  </div>

                  <div className="lp01-subscription-layout" style={{ marginTop: 24 }}>
                    <div
                      className="lp01-subscription-figure"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 250,
                      }}
                    >
                      <img
                        src="/cost-compare.png"
                        alt="コスト比較"
                        style={{ width: '100%', maxWidth: 400, height: 'auto', objectFit: 'contain' }}
                      />
                    </div>

                    <div className="lp01-subscription-copy" style={{ display: 'grid', placeItems: 'center', minHeight: 250 }}>
                      <div className="lp01-subscription-copy-inner" style={{ textAlign: 'center', color: '#222', lineHeight: 1.65 }}>
                        <p className="lp01-subscription-note" style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
                          どのタレント・素材も一律料金！
                        </p>
                        <p style={{ margin: '10px 0 0', fontSize: 'clamp(26px, 3vw, 46px)', fontWeight: 900, color: '#67b8e5', letterSpacing: '-0.04em' }}>
                          始めやすい価格設計
                        </p>
                        <p style={{ margin: '12px auto 0', maxWidth: 340, fontSize: 16, color: '#5b6d65' }}>
                          中小企業でもブランド訴求を始めやすいよう、導入ハードルを下げた形で設計しています。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                background: '#e6f6ff',
                borderRadius: 34,
                padding: '28px 28px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div
                style={{
                  width: 'min(1280px, 100%)',
                  margin: '0 auto',
                  background: 'rgba(255,255,255,0.96)',
                  borderRadius: 24,
                  padding: '34px 34px 28px',
                  boxShadow: '0 20px 44px rgba(130, 180, 216, 0.08)',
                }}
              >
                <div className="lp01-asset-layout">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      src="/lp-sample.png"
                      alt="タレント素材活用例"
                      style={{ width: '100%', maxWidth: 480, height: 'auto', borderRadius: 12, objectFit: 'contain' }}
                    />
                  </div>
                  <div style={{ padding: '10px 18px 10px 6px' }}>
                    <h3 style={{ margin: 0, fontSize: 'clamp(34px, 4vw, 60px)', lineHeight: 1.2, color: '#67b8e5', letterSpacing: '-0.04em' }}>
                      豊富な素材が
                      <br />
                      すぐに使える
                    </h3>
                    <div style={{ width: 'min(440px, 100%)', height: 2, background: '#8dcdf1', margin: '22px 0 0' }} />
                    <p style={{ margin: '26px 0 0', fontSize: 18, lineHeight: 1.9, color: '#333', maxWidth: 520 }}>
                      写真や動画など多彩なコンテンツがサブスク形式で利用でき、
                      即時性の高い広告運用を実現します。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                background: '#e6f6ff',
                borderRadius: 34,
                padding: '28px 28px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div
                style={{
                  width: 'min(1280px, 100%)',
                  margin: '0 auto',
                  background: 'rgba(255,255,255,0.96)',
                  borderRadius: 24,
                  padding: '34px 34px 18px',
                  boxShadow: '0 20px 44px rgba(130, 180, 216, 0.08)',
                }}
              >
                <div className="lp01-brand-layout">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      src="/brand-sample.png"
                      alt="ブランディング活用例"
                      style={{ width: '100%', maxWidth: 300, height: 'auto', objectFit: 'contain' }}
                    />
                  </div>
                  <div style={{ padding: '56px 14px 0 0' }}>
                    <h3 style={{ margin: 0, fontSize: 'clamp(34px, 4vw, 58px)', lineHeight: 1.2, color: '#67b8e5', letterSpacing: '-0.04em' }}>
                      企業全体を
                      <br />
                      ブランディング
                    </h3>
                    <div style={{ width: 'min(460px, 100%)', height: 2, background: '#8dcdf1', margin: '22px 0 0' }} />
                    <p style={{ margin: '24px 0 0', fontSize: 18, lineHeight: 1.9, color: '#333', maxWidth: 500 }}>
                      業種をまたいでタレントを起用することで、企業全体のブランディングを強化。
                      さらに、集客や認知拡大だけでなく、採用活動にも活用できます。
                    </p>
                    <p style={{ margin: '20px 0 0', fontSize: 14, color: '#777', textAlign: 'right' }}>※ 規定あり</p>
                  </div>
                </div>

                <div style={{ position: 'relative', minHeight: 220, marginTop: 14 }}>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className="lp01-brand-banner">
                      タレントを効果的に起用し
                      <div
                        style={{
                          position: 'absolute',
                          bottom: -16,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: 0,
                          height: 0,
                          borderLeft: '14px solid transparent',
                          borderRight: '14px solid transparent',
                          borderTop: '18px solid #55aee0',
                        }}
                      />
                    </div>
                  </div>
                  <h4 style={{ margin: '28px 0 0', textAlign: 'center', fontSize: 'clamp(34px, 4vw, 56px)', lineHeight: 1.25, color: '#222', letterSpacing: '-0.03em' }}>
                    お客様に選ばれるクリニック・サロンへ！
                  </h4>

                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 34,
                background: '#fff',
                padding: '44px 24px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  left: -90,
                  top: 80,
                  width: 360,
                  height: 520,
                  background:
                    'repeating-linear-gradient(140deg, rgba(131, 233, 240, 0.08) 0 2px, transparent 2px 12px)',
                  transform: 'rotate(18deg)',
                  pointerEvents: 'none',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  right: -40,
                  bottom: -20,
                  width: 320,
                  height: 260,
                  background:
                    'repeating-linear-gradient(140deg, rgba(131, 233, 240, 0.08) 0 2px, transparent 2px 12px)',
                  transform: 'rotate(18deg)',
                  pointerEvents: 'none',
                }}
              />

              <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#222' }}>
                  Nuntが
                </p>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 32,
                    padding: '0 18px',
                    background: '#b37fe8',
                    color: '#fff',
                    fontSize: 16,
                    fontWeight: 700,
                    marginTop: 10,
                  }}
                >
                  クリニック・サロンから
                </div>
                <h2 style={{ margin: '14px 0 0', fontSize: 'clamp(24px, 3.2vw, 44px)', lineHeight: 1.15, letterSpacing: '-0.05em', color: '#222' }}>
                  選ばれる<span style={{ color: '#75d2d8' }}>3</span>つの<span style={{ color: '#c09ae8' }}>理由</span>
                </h2>
              </div>

              <div style={{ position: 'relative', zIndex: 1, width: 'min(760px, 100%)', margin: '42px auto 0' }}>
                <div
                  style={{
                    background: '#fff',
                    borderRadius: 24,
                    overflow: 'hidden',
                    boxShadow: '0 20px 44px rgba(14,40,32,0.1)',
                  }}
                >
                  <img
                    src="/reason-sample.png"
                    alt="タレント活用イメージ"
                    style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover', borderRadius: '24px 24px 0 0' }}
                  />
                  <div style={{ padding: '24px 30px 28px' }}>
                    <h3 style={{ margin: 0, fontSize: 20, lineHeight: 1.35, color: '#222' }}>
                      豊富な<span style={{ color: '#55aee0' }}>タレントラインナップ</span>
                    </h3>
                    <div
                      style={{
                        marginTop: 16,
                        background: '#67b8e5',
                        color: '#fff',
                        display: 'inline-flex',
                        minHeight: 40,
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 20px',
                        fontSize: 18,
                        fontWeight: 800,
                      }}
                    >
                      あなたのクリニック・サロンに最適な「顔」を見つけられる！
                    </div>
                    <p style={{ margin: '18px 0 0', fontSize: 16, lineHeight: 1.9, color: '#444' }}>
                      業界やターゲット層に応じた幅広い素材活用が可能。美容領域に合う表現を選び、
                      LPやSNSで統一感のあるブランド訴求を進められます。
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '36px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 34,
                background: '#fff',
                padding: '10px 24px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  right: -40,
                  top: -40,
                  width: 360,
                  height: 260,
                  background:
                    'repeating-linear-gradient(140deg, rgba(131, 233, 240, 0.08) 0 2px, transparent 2px 12px)',
                  transform: 'rotate(16deg)',
                  pointerEvents: 'none',
                }}
              />

              <div style={{ position: 'relative', zIndex: 1, width: 'min(760px, 100%)', margin: '42px auto 0' }}>
                <div style={{ display: 'none' }}>
                  02
                </div>

                <div
                  style={{
                    background: '#fff',
                    borderRadius: 24,
                    overflow: 'hidden',
                    boxShadow: '0 20px 44px rgba(14,40,32,0.1)',
                  }}
                >
                  <img
                    src="/reason2-sample.png"
                    alt="導入しやすい料金プランイメージ"
                    style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover', borderRadius: '24px 24px 0 0' }}
                  />

                  <div style={{ padding: '24px 30px 28px' }}>
                    <h3 style={{ margin: 0, fontSize: 20, lineHeight: 1.35, color: '#222' }}>
                      導入しやすい<span style={{ color: '#55aee0' }}>柔軟な料金プラン</span>
                    </h3>
                    <div
                      style={{
                        marginTop: 16,
                        background: '#67b8e5',
                        color: '#fff',
                        display: 'inline-flex',
                        minHeight: 40,
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 20px',
                        fontSize: 18,
                        fontWeight: 800,
                      }}
                    >
                      選べるプランで予算に合わせて無理なくスタート！
                    </div>
                    <p style={{ margin: '18px 0 0', fontSize: 16, lineHeight: 1.9, color: '#444' }}>
                      初期費用0円、月額定額制でコスト管理も簡単。地域密着型のクリニックやサロンでも、
                      始めやすい形でブランド訴求をスタートできます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '36px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 34,
                background: '#fff',
                padding: '10px 24px 34px',
                boxShadow: '0 24px 70px rgba(132, 176, 228, 0.08)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  right: -40,
                  top: -40,
                  width: 360,
                  height: 260,
                  background:
                    'repeating-linear-gradient(140deg, rgba(131, 233, 240, 0.08) 0 2px, transparent 2px 12px)',
                  transform: 'rotate(16deg)',
                  pointerEvents: 'none',
                }}
              />

              <div style={{ position: 'relative', zIndex: 1, width: 'min(760px, 100%)', margin: '42px auto 0' }}>
                <div style={{ display: 'none' }}>
                  03
                </div>

                <div
                  style={{
                    background: '#fff',
                    borderRadius: 24,
                    overflow: 'hidden',
                    boxShadow: '0 20px 44px rgba(14,40,32,0.1)',
                  }}
                >
                  <img
                    src="/reason03.png"
                    alt="ブランドに合わせて自由に使える"
                    style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover', borderRadius: '24px 24px 0 0' }}
                  />

                  <div style={{ padding: '24px 30px 28px' }}>
                    <h3 style={{ margin: 0, fontSize: 20, lineHeight: 1.35, color: '#222' }}>
                      ブランドを際立たせる<span style={{ color: '#55aee0' }}>自由な広告制作</span>
                    </h3>
                    <div
                      style={{
                        marginTop: 16,
                        background: '#67b8e5',
                        color: '#fff',
                        display: 'inline-flex',
                        minHeight: 40,
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 20px',
                        fontSize: 18,
                        fontWeight: 800,
                      }}
                    >
                      クリニック・サロンに寄り添った広告が作れる！
                    </div>
                    <p style={{ margin: '18px 0 0', fontSize: 16, lineHeight: 1.9, color: '#444' }}>
                      ブランドイメージに合わせて素材を柔軟に活用可能。
                      クリニックやサロン独自の魅力を引き出した広告展開につなげられます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 34,
                background: 'linear-gradient(180deg, #6bbaf2 0%, #63b4ef 70%, #68b8f1 100%)',
                padding: 'clamp(36px, 5vw, 68px) clamp(18px, 4vw, 34px) 40px',
                boxShadow: '0 24px 70px rgba(82, 160, 224, 0.18)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  right: -120,
                  bottom: -120,
                  width: '56%',
                  height: 360,
                  background: 'linear-gradient(135deg, rgba(196, 152, 236, 0.94) 0%, rgba(185, 142, 235, 0.92) 100%)',
                  transform: 'rotate(-20deg)',
                  transformOrigin: 'center',
                }}
              />

              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ textAlign: 'center', color: '#fff' }}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 'clamp(24px, 3vw, 38px)',
                      fontWeight: 800,
                      letterSpacing: '-0.02em',
                      textShadow: '0 6px 16px rgba(31, 88, 137, 0.22)',
                    }}
                  >
                    Nuntで
                  </p>
                  <div
                    style={{
                      margin: '14px auto 0',
                      width: 'min(100%, 340px)',
                      minHeight: 42,
                      display: 'grid',
                      placeItems: 'center',
                      background: '#fff',
                      color: '#7ea0b6',
                      fontSize: 'clamp(18px, 2vw, 26px)',
                      fontWeight: 700,
                      boxShadow: '0 10px 24px rgba(52, 129, 196, 0.16)',
                    }}
                  >
                    知名度 ＆ 信頼感UP
                  </div>
                  <h2
                    style={{
                      margin: '18px 0 0',
                      fontSize: 'clamp(24px, 3.2vw, 44px)',
                      lineHeight: 1,
                      letterSpacing: '-0.05em',
                      textShadow: '0 10px 24px rgba(31, 88, 137, 0.22)',
                    }}
                  >
                    活用イメージ
                  </h2>
                </div>

                <div
                  className="lp01-usecase-grid"
                  style={{ marginTop: 34 }}
                >
                  {useCases.map((item, index) => (
                    <article
                      key={item.title}
                      style={{
                        background: '#fff',
                        borderRadius: 0,
                        overflow: 'hidden',
                        boxShadow: '0 22px 44px rgba(45, 88, 122, 0.18)',
                      }}
                    >
                      <div
                        style={{
                          background: index === 0 ? '#f7efe9' : '#f6f2ed',
                        }}
                      >
                        <img
                          src={index === 0 ? '/lp-ex1.png' : '/lp-ex2.png'}
                          alt="活用イメージ"
                          style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            objectFit: 'contain',
                          }}
                        />
                      </div>

                      <div style={{ padding: '22px 20px 28px', textAlign: 'center' }}>
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14 }}>
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: 88,
                              minHeight: 42,
                              background: '#62b6ea',
                              color: '#fff',
                              fontSize: 18,
                              fontWeight: 800,
                            }}
                          >
                            {item.label}
                          </span>
                          <span style={{ fontSize: 18, fontWeight: 700, color: '#26323c' }}>{item.kicker}</span>
                        </div>
                        <h3 style={{ margin: '18px 0 0', fontSize: 'clamp(22px, 2.5vw, 38px)', lineHeight: 1.25, color: '#222', letterSpacing: '-0.03em' }}>
                          {item.title}
                        </h3>
                        <p style={{ margin: '14px auto 0', maxWidth: '30em', fontSize: 15, lineHeight: 1.85, color: '#5f6c77' }}>
                          {item.body}
                        </p>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 0' }}>
          <div style={shellStyle}>
            <div
              style={{
                background: '#fff',
                borderRadius: 34,
                padding: 'clamp(34px, 5vw, 62px) clamp(18px, 3.6vw, 32px) 26px',
                boxShadow: '0 24px 70px rgba(109, 154, 201, 0.1)',
              }}
            >
              <h2
                style={{
                  margin: 0,
                  textAlign: 'center',
                  fontSize: 'clamp(24px, 3.2vw, 44px)',
                  lineHeight: 1.1,
                  letterSpacing: '-0.04em',
                  color: '#222',
                }}
              >
                ご利用開始までの流れ
              </h2>

              <div
                className="lp01-flow-grid"
                style={{ marginTop: 42 }}
              >
                {flowSteps.map((item) => (
                  <article key={item.step} className="lp01-flow-article" style={{ minWidth: 0 }}>
                    <div
                      className="lp01-flow-step-header"
                      style={{
                        minHeight: 110,
                        borderRadius: '0 48px 48px 0',
                        background: '#60b4e6',
                        color: '#fff',
                        display: 'grid',
                        placeItems: 'center',
                        padding: '14px 16px',
                        textAlign: 'center',
                        boxShadow: '0 16px 28px rgba(96, 180, 230, 0.2)',
                      }}
                    >
                      <div className="lp01-flow-step-header-inner">
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: 86,
                            minHeight: 34,
                            borderRadius: 12,
                            background: '#fff',
                            color: '#60b4e6',
                            fontSize: 17,
                            fontWeight: 800,
                          }}
                        >
                          {item.step}
                        </div>
                        <h3 style={{ margin: '12px 0 0', fontSize: 'clamp(13px, 1.2vw, 18px)', lineHeight: 1.25, fontWeight: 800, whiteSpace: 'nowrap' }}>
                          {item.title}
                        </h3>
                      </div>
                    </div>

                    <div className="lp01-flow-step-content">
                      <div
                        className="lp01-flow-step-icon"
                        style={{
                          margin: '20px auto 0',
                          width: 146,
                          height: 146,
                          background: '#edf8ff',
                          display: 'grid',
                          placeItems: 'center',
                          flexShrink: 0,
                        }}
                      >
                        {item.icon === 'list' ? (
                          <img src="/step01-icon.png" alt="タレント選択" style={{ width: 130, height: 130, objectFit: 'contain' }} />
                        ) : null}

                        {item.icon === 'checklist' ? (
                          <img src="/step02-icon.png" alt="審査" style={{ width: 130, height: 130, objectFit: 'contain' }} />
                        ) : null}

                        {item.icon === 'document' ? (
                          <img src="/step03-icon.png" alt="ご契約" style={{ width: 130, height: 130, objectFit: 'contain' }} />
                        ) : null}

                        {item.icon === 'meeting' ? (
                          <img src="/step04-icon.png" alt="素材提供・制作" style={{ width: 130, height: 130, objectFit: 'contain' }} />
                        ) : null}

                        {item.icon === 'monitor' ? (
                          <img src="/step05-icon.png" alt="ご利用開始" style={{ width: 130, height: 130, objectFit: 'contain' }} />
                        ) : null}
                      </div>

                      <p
                        className="lp01-flow-step-body"
                        style={{
                          margin: '18px 4px 0',
                          fontSize: 15,
                          lineHeight: 1.9,
                          color: '#333',
                          letterSpacing: '-0.01em',
                        }}
                      >
                        {item.body}
                      </p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '64px 0 76px' }}>
          <div style={shellStyle}>
            <div
              style={{
                background: '#e9fbff',
                borderRadius: 34,
                padding: 'clamp(34px, 5vw, 64px) clamp(18px, 4vw, 36px) 42px',
                boxShadow: '0 24px 70px rgba(109, 154, 201, 0.1)',
              }}
            >
              <h2
                style={{
                  margin: 0,
                  textAlign: 'center',
                  fontSize: 'clamp(24px, 3.2vw, 44px)',
                  lineHeight: 1.1,
                  letterSpacing: '-0.04em',
                  color: '#222',
                }}
              >
                よくあるご質問
              </h2>

              <div style={{ margin: '34px auto 0', width: 'min(1140px, 100%)', display: 'grid', gap: 24 }}>
                {faqs.map((item, index) => {
                  const isOpen = openFaqIndex === index;

                  return (
                    <div
                      key={item.question}
                      style={{
                        background: '#fff',
                        borderRadius: 26,
                        boxShadow: '0 18px 34px rgba(144, 187, 211, 0.12)',
                        overflow: 'hidden',
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenFaqIndex(isOpen ? -1 : index)}
                        style={{
                          width: '100%',
                          minHeight: 92,
                          border: 'none',
                          background: 'transparent',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 18,
                          padding: '20px 28px 20px 34px',
                          cursor: 'pointer',
                          textAlign: 'left',
                        }}
                      >
                        <span style={{ fontSize: 'clamp(22px, 2vw, 30px)', lineHeight: 1.55, color: '#333', fontWeight: 700 }}>
                          {item.question}
                        </span>
                        <span
                          style={{
                            width: 34,
                            height: 34,
                            flexShrink: 0,
                            position: 'relative',
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              left: 6,
                              top: 12,
                              width: 18,
                              height: 18,
                              borderRight: '3px solid #77bfe8',
                              borderBottom: '3px solid #77bfe8',
                              transform: isOpen ? 'rotate(-135deg)' : 'rotate(45deg)',
                              transition: 'transform 0.2s ease',
                            }}
                          />
                        </span>
                      </button>

                      {isOpen ? (
                        <div
                          style={{
                            padding: '0 34px 26px',
                            fontSize: 16,
                            lineHeight: 1.95,
                            color: '#5a6772',
                          }}
                        >
                          {item.answer}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '0 0 76px' }}>
          <div style={shellStyle}>
            <div
              style={{
                background: '#fff',
                borderRadius: 34,
                overflow: 'hidden',
                boxShadow: '0 24px 70px rgba(109, 154, 201, 0.12)',
              }}
            >
              <div
                className="lp01-final-cta-container"
                style={{
                  position: 'relative',
                  minHeight: 402,
                  background: 'linear-gradient(115deg, #f5f1ff 0%, #fff7fb 54%, #eef7ff 100%)',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 22,
                    width: '86%',
                    height: 398,
                    borderRadius: '0 110px 110px 0',
                    background: 'linear-gradient(135deg, rgba(240, 247, 255, 0.96) 0%, rgba(246, 232, 255, 0.92) 48%, rgba(255, 238, 247, 0.92) 100%)',
                    boxShadow: '0 22px 44px rgba(130, 139, 199, 0.12)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      left: -100,
                      bottom: -12,
                      width: 560,
                      height: 180,
                      background: 'linear-gradient(135deg, rgba(200, 90, 201, 0.18) 0%, rgba(233, 130, 173, 0.16) 100%)',
                      transform: 'rotate(8deg)',
                    }}
                  />
                  <img
                    className="lp01-final-cta-logo"
                    src="/nuntlogo.png"
                    alt="Nunt"
                    style={{
                      position: 'absolute',
                      left: -20,
                      top: 16,
                      width: 'clamp(170px, 15vw, 260px)',
                      height: 'auto',
                    }}
                  />

                  <div
                    className="lp01-final-cta-circle"
                    style={{
                      position: 'absolute',
                      left: 346,
                      top: 28,
                      width: 148,
                      height: 148,
                      borderRadius: '50%',
                      background: '#f6ffff',
                      border: '2px solid rgba(201, 130, 210, 0.5)',
                      display: 'grid',
                      placeItems: 'center',
                      boxShadow: '0 14px 28px rgba(145, 74, 166, 0.1)',
                      textAlign: 'center',
                      color: '#a253b0',
                      fontWeight: 800,
                      lineHeight: 1.45,
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 28, lineHeight: 1 }}>♛</div>
                      地域で一番
                      <br />
                      選ばれる
                    </div>
                  </div>

                  <img
                    src="/hero-chara.png"
                    alt="キャラクター"
                    className="lp01-final-cta-chara"
                    style={{
                      position: 'absolute',
                      left: 80,
                      bottom: 0,
                      width: 300,
                      height: 'auto',
                      objectFit: 'contain',
                      objectPosition: 'bottom',
                    }}
                  />

                  <div
                    className="lp01-final-cta-text"
                    style={{
                      position: 'absolute',
                      right: 70,
                      top: 112,
                      display: 'grid',
                      gap: 14,
                    }}
                  >
                    <div
                      style={{
                        background: '#fff',
                        padding: '10px 22px',
                        fontSize: 'clamp(34px, 3.8vw, 62px)',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        color: '#bd5ab8',
                        letterSpacing: '-0.04em',
                        boxShadow: '0 14px 28px rgba(145, 74, 166, 0.09)',
                      }}
                    >
                      美容クリニック
                    </div>
                    <div
                      style={{
                        background: '#fff',
                        padding: '10px 22px',
                        fontSize: 'clamp(34px, 3.8vw, 62px)',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        color: '#bd5ab8',
                        letterSpacing: '-0.04em',
                        boxShadow: '0 14px 28px rgba(145, 74, 166, 0.09)',
                      }}
                    >
                      エステサロンへ!
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  padding: '24px clamp(18px, 4vw, 36px) 28px',
                  background: '#fff',
                  textAlign: 'center',
                }}
              >
                <p className="lp01-final-cta-desc" style={{ margin: 0, fontSize: 'clamp(24px, 2.5vw, 38px)', fontWeight: 700, color: '#333', lineHeight: 1.6 }}>
                  タレント起用と戦略的広告で、SNSで際立つ存在に。
                </p>

                <div style={{ marginTop: 16 }}>
                  <p style={{ margin: 0, color: '#a760b4', fontSize: 'clamp(20px, 2vw, 30px)', fontWeight: 500 }}>
                    成功事例・サービス詳細はこちら
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 6 }}>
                    <span style={{ width: 180, height: 3, background: '#b25ec1' }} />
                    <span style={{ color: '#b25ec1', fontSize: 28, lineHeight: 1 }}>|</span>
                    <span style={{ width: 180, height: 3, background: '#b25ec1' }} />
                  </div>
                </div>

                <div
                  className="lp01-cta-row"
                  style={{
                    marginTop: 22,
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: 22,
                    alignItems: 'stretch',
                    maxWidth: 1080,
                    marginInline: 'auto',
                  }}
                >
                  <a
                    href="/download"
                    style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 76,
                    padding: '0 24px',
                    borderRadius: 30,
                    background: 'linear-gradient(90deg, #c164b5 0%, #e2779f 100%)',
                    color: '#fff',
                    textDecoration: 'none',
                    boxShadow: '0 12px 24px rgba(184, 88, 151, 0.15)',
                  }}
                >
                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: '50%', background: 'rgba(255,255,255,0.11)', fontSize: 18, fontWeight: 800 }}>
                      無料
                    </span>
                    <span style={{ fontSize: 'clamp(21px, 2vw, 30px)', fontWeight: 800, letterSpacing: '-0.01em' }}>資料ダウンロード</span>
                    <span style={{ fontSize: 30, lineHeight: 1, opacity: 0.84 }}>›</span>
                  </a>

                  <a
                    href="/contact"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    minHeight: 76,
                    padding: '0 24px',
                    borderRadius: 30,
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(251,247,255,0.9) 100%)',
                    color: '#92539d',
                    textDecoration: 'none',
                    border: '2px solid #d2a6db',
                    boxShadow: '0 12px 24px rgba(145, 74, 166, 0.07)',
                  }}
                >
                    <span className="lp01-final-cta-email-icon" aria-hidden="true">
                      <span className="lp01-envelope" />
                    </span>
                    <span style={{ fontSize: 'clamp(21px, 1.9vw, 29px)', fontWeight: 700, letterSpacing: '-0.01em' }}>無料で相談する</span>
                    <span style={{ fontSize: 30, lineHeight: 1, opacity: 0.68 }}>›</span>
                  </a>
                </div>
              </div>

              <footer
                style={{
                  background: 'linear-gradient(90deg, #f7eefb 0%, #f5f7ff 50%, #eef8ff 100%)',
                  borderTop: '1px solid rgba(109, 154, 201, 0.14)',
                  padding: '28px 18px 30px',
                  textAlign: 'center',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '14px 34px', color: '#666', fontSize: 15 }}>
                  <a href="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>プライバシーポリシー</a>
                  <a href="/contact" style={{ color: 'inherit', textDecoration: 'none' }}>会社概要</a>
                </div>
                <p style={{ margin: '18px 0 0', color: '#7b7b7b', fontSize: 14 }}>
                  Copyright © 2026 Patlush all rights reserved.
                </p>
              </footer>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
